import { render, staticRenderFns } from "./CompanySPUploadCertificationsForm.vue?vue&type=template&id=910886ac&scoped=true"
import script from "./CompanySPUploadCertificationsForm.vue?vue&type=script&lang=js"
export * from "./CompanySPUploadCertificationsForm.vue?vue&type=script&lang=js"
import style0 from "./CompanySPUploadCertificationsForm.vue?vue&type=style&index=0&id=910886ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910886ac",
  null
  
)

export default component.exports